module.exports = __webpack_public_path__ + "img/hibob.b547c326.svg";